import {IntermediatePart} from "../../intermediatePart";
import {SLAT_WALL_POSITIONS} from "../../constants";

export default class SlatWall extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'slat_wall';
    this.partName = 'Slatwall';
    this.translateId = "visualizer.kitchen.walls.slat_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.slatWallType = SLAT_WALL_POSITIONS[0];
    this.hasAdditionalParts = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new SlatWall());
  }

  // load(dbFeature) {
  //   if (!dbFeature.metaData["Part"]) {
  //     dbFeature.metaData["Part"] = ["1"];
  //   }
  //   if (!dbFeature.metaData["Height"]) {
  //     dbFeature.metaData["Height"] = ["2"];
  //   }
  //   const isMainFeature = (dbFeature.metaData["Part"][0] === "1") && (dbFeature.metaData["Height"][0] === "2");
  //   return super.load_(dbFeature, new SlatWall(false, SlatWall),
  //     true, isMainFeature ? 'features' : 'featuresParts');
  // }

  // getAdditionalPartsConditions(arrayOfConditions = []) {
  //   let partMeta, heightMeta;
  //   switch (this.slatWallType) {
  //     case SLAT_WALL_POSITIONS[0]:
  //       partMeta = "2";
  //       heightMeta = "2";
  //     default:
  //       return arrayOfConditions
  //   }
  //   return [...arrayOfConditions, {
  //     propName: "Part",
  //     propValue:
  //   }, {
  //     propName: "Height",
  //     propValue:
  //   }]
  // }

  // showLayerPositionsModal() {
  //   return true
  // }
}
